import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['content'];

  open() {
    const template = document.getElementById('rationale-content');
    if (!template || !this.hasContentTarget) return;
    this.contentTarget.innerHTML = template.innerHTML;
    this.application
      .getControllerForElementAndIdentifier(this.element, 'panel-editor')
      ?.openPanel();
  }
}
